module.exports = __webpack_public_path__ + "img/slot-machine.71b4ceb1.png";